module.exports = "/assets/64f2bc3d8ec52e924afdfab16ac99861.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/UG.png
// module id = 3009
// module chunks = 0